import { createUseStyles } from 'react-jss'
import { tabletDown } from '../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  editProfileHeading: {
    marginBottom: 8
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  content: {
    marginTop: 20
  },
  icon: {
    marginBottom: 24
  },
  uploadFileButtonLabel: {
    width: '100%'
  },
  uploadButton: {
    width: '100%'
  },
  filePreview: {
    marginTop: [8, '!important'],
    padding: '3px 12px'
  },
  [`@media screen and (${tabletDown})`]: {
    content: {
      marginTop: 20
    }
  }
})

export default useStyles
